import type { AppSettings } from './AppSettingsContext.types';
import { currentVersion } from './AppSettingsContextProvider.migrations';

export const appSettingsDefaultValues: AppSettings = {
  _version: currentVersion,
  themeMode: 'dark',
  isSideNavigationOpen: false,
};
